import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element-purple-medium.svg'
import { ReactComponent as IconWarning } from '@/assets/svgs/warning-exclamation-medium.svg'
import Button from "@/components/Button"
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import MultiCheckDropdown from '@/components/MultiCheckWithCountDropdown/index'
import SingleSelectDropdown from '@/components/SingleSelectDropdown/index'
import { ToastContext } from '@/context/toast/index'
import usePackages from '@/hooks/use-packages/index.js'
import rem from '@/utils/rem'
import { isEmpty } from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'


function AddDataElementModal({ visible, close, placementList, currentPackage, reload }) {

	const user = useSelector(state => state.auth.user)

	const [selectedPlacement, setSelectedPlacement] = useState({})
	const [selectedRecipient, setSelectedRecipient] = useState({})
	const [packageRecipientOrgId, setPackageRecipientOrgId] = useState('')
	const [errorMsg, setErrorMsg] = useState("")
	const [packagePlacementList, setPackagePlacementList] = useState([])

	const MESSAGETYPE = {
		placement: "placement",
		recipient: "recipient"
	}

	const {
		NODE_TYPE,
		getDataElements,
		dataElements,
		setDataElements,
		getParticipants,
		participantList,
		addRemoveDataElements,
		packageErrorMsg,
	} = usePackages()

	const { addToastMessage } = useContext(ToastContext)

	const dataElementIsEmpty = dataElements?.every(item => item.$selected === false)
	const hasOnlyPackageLvl = (placementList?.length === 1 && placementList[0]?.placementType === NODE_TYPE.package) || false

	useEffect(() => {
		if (hasOnlyPackageLvl && visible) {
			getParticipants({
				parent_node_type: NODE_TYPE.package,
				parent_node_id: currentPackage.id
			})
			setSelectedPlacement(placementList[0])
		}
	}, [visible])

	/**if the recipient is not fix at the point of package creation,
	 * set the selected recipient under recipient selection dropdown
	 * **/
	// useEffect(() => {
	// 	if (!currentPackage.isVeridapt && participantList?.length) {
	// 		let allDERecipient = [...new Set(currentPackage.dataElements.map(s => s.recipientOrgId))].filter(s => s)
	// 		if (allDERecipient.length === 1) {
	// 			setPackageRecipientOrgId(allDERecipient[0])
	// 			recipientSelection(participantList.find(s => s.id === allDERecipient[0]));
	// 		}
	// 	}
	// }, [participantList]);

	useEffect(()=>{
		if(participantList?.length === 1){
			recipientSelection(participantList[0])
		}
	},[participantList])

	useEffect(()=>{
		const updatedPlacementList = placementList?.filter(placement => placement?.participants?.some(participant => participant.id === user.organizationId))
		setPackagePlacementList(updatedPlacementList)
	},[placementList])

	useEffect(() => {
		if (packageErrorMsg) {
			addToastMessage(packageErrorMsg, 'error')
		}
	}, [packageErrorMsg])

	function errorMsgMarkUp(msgType) {

		if (msgType === MESSAGETYPE.placement) {
			return { __html: "By changing your <span class='error-text--bold'>'Placement', 'Recipient'</span> and <span class='error-text--bold'>'Data Element'</span> value will be reset." }
		}

		if (msgType === MESSAGETYPE.recipient) {
			return { __html: "By changing your <span class='error-text--bold'>'Recipient', 'Data Element'</span> value will be reset." }
		}

		return { __html: "" }
	}

	function placementSelection(option) {
		if (!isEmpty(selectedRecipient) && option.id !== selectedPlacement.id) {
			setErrorMsg(MESSAGETYPE.placement)
			setSelectedRecipient({})
			setDataElements([])
		}

		setSelectedPlacement(option)

		getParticipants({
			parent_node_type: option.placementType,
			parent_node_id: option.id
		})
	}

	function recipientSelection(option) {
		// if ((!currentPackage.isVeridapt && packageRecipientOrgId.length && option.id !== packageRecipientOrgId) || (currentPackage.isVeridapt && !dataElementIsEmpty && option.id !== selectedRecipient.id)) {

		if (!dataElementIsEmpty && option.id !== selectedRecipient.id) {
			setErrorMsg(MESSAGETYPE.recipient)
		}

		setSelectedRecipient(option)

		getDataElements({
			org_id: option.id,
			parent_node_type: selectedPlacement.placementType,
			parent_node_id: selectedPlacement.id
		})
	}

	function closeModal() {
		close()
		setSelectedPlacement({})
		setSelectedRecipient({})
		setDataElements([])
		setErrorMsg("")
	}

	function addIsDisabled() {
		return isEmpty(selectedPlacement) || isEmpty(selectedRecipient) || dataElementIsEmpty
	}

	async function handleSubmit() {
		const submitDataElement = dataElements?.filter(dataElement => dataElement.$selected).map(dataElement => (
			{
				dataElementId: dataElement.id,
				elementName: dataElement.name,
				type: dataElement.type,
				parent_node_id: selectedPlacement.id,
				parent_node_type: selectedPlacement.placementType
			}
		))


		// TODO: A change in recipient, remove all DE [Will be handled by backend]
		// if (!currentPackage.isVeridapt) {
		// 	if (packageRecipientOrgId !== selectedRecipient.id) {
		// 		await addRemoveDataElements(currentPackage.id, "REMOVE",
		// 			currentPackage.dataElements.map(dataElement => {
		// 				return {
		// 					dataElementId: dataElement.dataElementId,
		// 					type: dataElement.type,
		// 					parent_node_id: dataElement.parent_node_id,
		// 					parent_node_type: dataElement.parent_node_type,
		// 				}
		// 			})
		// 		)
		// 	}
		// }

		await addRemoveDataElements(currentPackage.id, "ADD", submitDataElement, selectedRecipient.id)
		reload()
		closeModal()
	}

	return (
		<Modal visible={visible} variant='small' close={closeModal} >
			<CardConfigure >
				<CardConfigure.Header>
					<CardConfigure.Header.Icon type={"package"}></CardConfigure.Header.Icon>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package'}>
										<IconDataElement />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Add Data Element
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{!hasOnlyPackageLvl && (
							<div className="veridapt-add-data-element__placement-dropdown">
								<div className="veridapt-add-data-element__placement-dropdown-text">Placement</div>
								<SingleSelectDropdown
									placeholder="Select Placement"
									selectionList={packagePlacementList}
									selectedItem={selectedPlacement}
									handleSelectionClick={placementSelection}
									veridaptPrefix
								/>
							</div>
						)}

						<div className="veridapt-add-data-element__placement-dropdown">
							<div className="veridapt-add-data-element__placement-dropdown-text">
								<div className={`${!hasOnlyPackageLvl && isEmpty(selectedPlacement) ? "add-data-dropdown__disabled-text" : ""}`}>Recipient</div>
							</div>

							<SingleSelectDropdown
								placeholder="Select Recipient"
								selectionList={participantList}
								selectedItem={selectedRecipient}
								handleSelectionClick={recipientSelection}
								disable={hasOnlyPackageLvl ? false : isEmpty(selectedPlacement)}
								filterSearch={hasOnlyPackageLvl && participantList?.length > 5}
							/>

						</div>

						<div className="veridapt-add-data-element__placement-dropdown">
							<div className="veridapt-add-data-element__placement-dropdown-text">
								<div className={`${isEmpty(selectedRecipient) ? "add-data-dropdown__disabled-text" : ""}`}>Data Element</div>
							</div>
							<MultiCheckDropdown
								placeholder="Select Data Element"
								selectionList={dataElements}
								handleSelectionClick={setDataElements}
								disable={isEmpty(selectedRecipient) ? true : false}
								filterSearch
								prefix={<IconDataElement />}
							/>
						</div>
						{errorMsg && (
							<div className="veridapt-add-data-element__error-container">
								<div className="veridapt-add-data-element__error-icon"><IconWarning /></div>
								<div className="veridapt-add-data-element__error-text" >
									<div dangerouslySetInnerHTML={errorMsgMarkUp(errorMsg)} data-testid="error-msg" />
								</div>
							</div>
						)}
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button text="Cancel" submit={closeModal} btnText customeHover />
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>
						<Button round
							text={"Add"}
							submit={handleSubmit}
							disabled={addIsDisabled()}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal >
	)
}

export default AddDataElementModal
